import { Heading } from "@biom3/react";
import type { ReactElement } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ProtectedLayout } from "@/components";
import { AppToolbar, AppToolbarLeftSlot } from "@/components/core/AppToolbar";
import SEO from "@/components/core/Seo";
import { MainContent } from "@/components/layout/MainContent";
import { ExternalWalletsList } from "@/components/wallets/ExternaWallets";
import { usePreferences } from "@/context/PreferencesProvider";
export default function ExternalWallets() {
  const { t } = useTranslation();
  const { data: preferencesData, update: updatePreferences } = usePreferences();
  useEffect(() => {
    if (preferencesData?.hide_activation_badges.external_wallets === false) {
      updatePreferences({
        hide_activation_badges: {
          ...preferencesData?.hide_activation_badges,
          external_wallets: true,
        },
      });
    }
  }, [preferencesData, updatePreferences]);

  return (
    <>
      <AppToolbar>
        <AppToolbarLeftSlot>
          <Heading size="small">{t("screen_title_externalwallets")}</Heading>
        </AppToolbarLeftSlot>
      </AppToolbar>
      <ExternalWalletsList />
    </>
  );
}

ExternalWallets.getLayout = function getLayout(page: ReactElement) {
  return (
    <ProtectedLayout screen="ExternalWallets" userJourney="Wallets">
      <SEO
        description="Link your EOA wallet (or hardware wallet) to your Passport wallet."
        title="External Wallets | Immutable Play"
        url="https://play.immutable.com/external-wallets"
      />
      <MainContent>{page}</MainContent>
    </ProtectedLayout>
  );
};
